module.exports = __webpack_public_path__ + "img/apple-pay.c58266c9.svg";